import React from "react"
import { cn } from "@/lib/utils"
import { useIsMobile } from "@/hooks/use-mobile"
import { BusinessRole } from "@/schemas/business" // Changed import path
import { BusinessStatus } from "@/types/schema/commonSchema"
import BusinessCardContent from "./BusinessCardContent"
import BusinessCardMetadata from "./BusinessCardMetadata"
import { useBusinessCardRole } from "./useBusinessCardRole"
import { useBusinessCardNavigation } from "./BusinessCardNavigation"

interface BusinessCardProps {
  id: string
  title: string
  address: string
  status: BusinessStatus
  role: BusinessRole
  industry: string
  showActions?: boolean
  className?: string
  isGridView?: boolean
  package?: string
  logoUrl?: string
}

const BusinessCard: React.FC<BusinessCardProps> = ({
  id,
  title,
  address,
  status,
  role,
  industry,
  showActions = false,
  className,
  isGridView = false,
  package: businessPackage,
  logoUrl,
}) => {
  const isMobile = useIsMobile()
  const memberRole = useBusinessCardRole(id, role)
  const { handleBusinessClick } = useBusinessCardNavigation()

  // Make sure we always have a title to display, even if it's empty
  const displayTitle = title || "Unnamed Business"

  return (
    <div
      className={cn(
        "portfolio-card animate-fade-in cursor-pointer mb-1.5",
        isMobile ? "py-2 px-2.5" : "",
        isGridView ? "h-full flex flex-col" : "",
        className
      )}
      onClick={(e) => handleBusinessClick(e, id, status, businessPackage)}
      data-status={status}
    >
      <div
        className={cn(
          isGridView
            ? "flex flex-col h-full justify-between"
            : "flex flex-col md:flex-row md:items-center md:justify-between",
          "gap-1.5"
        )}
      >
        <BusinessCardContent
          title={displayTitle}
          address={address}
          logoUrl={logoUrl}
        />

        <BusinessCardMetadata
          status={status}
          memberRole={memberRole}
          businessId={id}
          isMobile={isMobile}
          isGridView={isGridView}
        />
      </div>
    </div>
  )
}

export default BusinessCard
